/**
 * Shared regex for parsing inline markdown constructs.
 * Matches (in order): bold-italic `***`, bold `**`, italic `*`, highlight `==`, code `` ` ``
 */
export const INLINE_MARKDOWN_REGEX =
  /\*\*\*(.+?)\*\*\*|\*\*(.+?)\*\*|\*(.+?)\*|==(.+?)==|`(.+?)`/g;
